import React from "react";
import { LoginPage } from "../../Pages/Login/Login"

function Login() {
  return <div>
    <LoginPage/>
  </div>;
}

export { Login };
